import { lazy, Suspense, useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Lenis from 'lenis'

import Hero from './components/sections/Hero'
const EBook = lazy(() => import('./pages/EBook'))

const Testimonials = lazy(() => import('./components/sections/Testimonials'))
const Access = lazy(() => import('./components/sections/Access'))
const Bonus = lazy(() => import('./components/sections/Bonus'))
const Guarantee = lazy(() => import('./components/sections/Guarantee'))
const TestimonialsPrints = lazy(() => import('./components/sections/TestimonialsPrints'))
const Pricing = lazy(() => import('./components/sections/Pricing'))
const About = lazy(() => import('./components/sections/About'))
const FAQ = lazy(() => import('./components/sections/FAQ'))
const Footer = lazy(() => import('./components/sections/Footer'))

function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    })

    function raf(time: number) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    return () => {
      lenis.destroy()
    }
  }, [])

  return (
    <main>
      <Hero />
      <Suspense fallback={null}>
        <Testimonials />
        <Access />
        <Bonus />
        <Guarantee />
        <TestimonialsPrints />
        <Pricing />
        <About />
        <FAQ />
        <Footer />
      </Suspense>
    </main>
  )
}

function App() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/e-book-gratuito" element={<EBook />} />
      </Routes>
    </Suspense>
  )
}

export default App
